/**
 * Utility function to track view_item_list event for pricing page
 * Fires on page load to track all visible pricing plans
 */

import { pushToDataLayer } from '@/util/analytics';

interface PricingItem {
  itemName: string;
  planCategory?: string;
  price: number | string;
  coupon?: string;
  discount?: number;
  index: number;
}

interface TrackViewItemListParams {
  currency?: string;
  planTier: 'monthly' | 'annual';
  items: PricingItem[];
}

export async function trackViewItemList(
  params: TrackViewItemListParams
): Promise<void> {
  try {
    await pushToDataLayer(
      {
        event: 'view_item_list',
        ecommerce: {
          currency: params.currency || 'USD',
          plan_tier: params.planTier,
          items: params.items.map((item) => ({
            item_name: item.itemName,
            item_category: item.planCategory || null,
            affiliation: 'SignupGenius',
            coupon: item.coupon || null,
            discount: item.discount || null,
            price: item.price,
            quantity: 1,
            index: item.index,
          })),
        },
      },
      {
        clearEcommerce: true, // Clear previous ecommerce object
        autoUserContext: true, // Auto-adds: user_id, new_registrant, membership_level, etc.
      }
    );
  } catch (error) {
    console.error(
      'Error tracking view_item_list:',
      error instanceof Error ? error.message : 'Unknown error'
    );
  }
}
